document.addEventListener("DOMContentLoaded", () => {
  // Select the sections you want to animate
  const elements = document.querySelectorAll(
    "h1, h2, h3, h4, h5, h6, p, img, .image, .text, .rte, .media"
  );

  // Add the initial fade-in class to each section
  elements.forEach(el => el.classList.add("fade-in-element"));

  // Set up the observer
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        // Stops observing once it has faded in
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  // Start observing
  elements.forEach(el => observer.observe(el));
});